export const refund = {
  REFUND_REQUESTED: 'refundRequested',
  REFUND_REQUEST_CLICKED: 'click'
}
